module.exports = {"data":{"site":{"siteMetadata":{"title":"Lukas Pustina","description":"The website, notes, projects and publications of Lukas Pustina","siteUrl":"https://lukas.pustina.de"}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 201
// module chunks = 60335399758886 114276838955818